import { HugeiconsIcon } from "@hugeicons/react";
import { GiftIcon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";
import useTranslations from "../../i18n/useTranslations";

const EmptyView: FC = () => {
  const t = useTranslations();

  return (
    <div
      data-slot="empty-view"
      className="flex flex-col items-center gap-4 px-2 pt-0 pb-6 text-center"
    >
      <span className="grid size-16 place-items-center rounded-full bg-card">
        <HugeiconsIcon icon={GiftIcon} className="size-7 text-primary" />
      </span>
      <p className="font-semibold text-foreground text-xl">
        {t("reward_center.empty.title")}
      </p>
      <p className="text-muted-foreground text-sm">
        {t("reward_center.empty.description")}
      </p>
    </div>
  );
};

export default EmptyView;
